<template>
  <a-switch :checked="switchValue" @change="change" />
</template>

<script>
export default {
  name: "dol-switch",
  props: {
    value: {},
    valueType: {type: String, default: 'Number'}, //Boolean, Number
  },
  data(){
    return {};
  },
  computed: {
    switchValue(){
      return !!this.value;
    }
  },
  methods: {
    change(value){
      let finalValue;
      switch (this.valueType){
        case 'Number': finalValue = value?1:0; break;
        default: finalValue = value;
      }
      this.$emit('input', finalValue);
    }
  },
}
</script>
